
export default {
    POST_ORDER_DETERMINED_ADDRESS: '/api/v1/order-determined/address',
    POST_ORDER_DETERMINED_BUILDING: '/api/v1/order-determined/building',
    POST_ORDER_DETERMINED_ADDRESS_BY_MERCHANT: '/api/v1/order-determined/address-merchant',
    POST_ORDER_DETERMINED_BUILDING_BY_MERCHANT: '/api/v1/order-determined/building-merchant',
    POST_ORDER_DETERMINED_MINUTE_MODIFY: '/api/v1/order-determined/minute',
}